var _path, _path2, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCheckCircle(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0 20C0 8.95431 8.95431 0 20 0C31.0457 0 40 8.95431 40 20C40 31.0457 31.0457 40 20 40C8.95431 40 0 31.0457 0 20Z",
    fill: "url(#paint0_linear_15167_20747)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M18.7386 18.9596C18.8533 19.0916 18.9563 19.2113 19.0471 19.3175C19.2569 19.0139 19.5423 18.6023 19.8958 18.0952C20.7108 16.9262 21.8884 15.2492 23.3391 13.2167C23.9074 12.4204 25.0041 11.9552 25.9944 12.5046C26.5833 12.8314 27.2861 13.3383 27.8396 14.0927C28.3886 14.8409 28.2268 15.7816 27.7991 16.4296C24.588 21.2944 22.2704 24.2575 20.9802 25.7992C20.1363 26.8078 18.662 26.8778 17.7148 25.9796C16.4704 24.7996 14.4863 22.8058 12.4225 20.2782C11.842 19.5673 11.6702 18.4885 12.3091 17.6699C12.7234 17.1389 13.1918 16.6891 13.6085 16.3372C14.5289 15.5601 15.8151 15.7697 16.5775 16.5773C17.4954 17.5497 18.2315 18.3758 18.7386 18.9596Z",
    fill: "white"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_15167_20747",
    x1: 20,
    y1: 0,
    x2: 20,
    y2: 40,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#EEF6A6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0001,
    stopColor: "#C4EEB9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.59375,
    stopColor: "#45AB9B"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCheckCircle);
export default __webpack_public_path__ + "static/media/checkCircle.db2355556db60f954a93c9d2a5a8164c.svg";
export { ForwardRef as ReactComponent };